<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <img class="mr-2" :src="require(`@/assets/appIcon-apps--PaymentLinks.svg`)" width="18">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{name: 'LinkList'}" class="subtitle-1 routerLink font-weight-medium">Links</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            <v-text-field class="d-inline-block" v-model="$v.object.name.$model" :error="$v.object.name.$error" maxlength="56" outlined single-line dense background-color="white" hide-details>
              <template v-slot:append>
                <v-tooltip right max-width="280px" transition="scale-transition">
                  <template v-slot:activator="{ on }">
                    <v-icon class="mr-2 mt-0" v-on="on" size="20" color="secondary">mdi-information</v-icon>
                  </template>
                  <span>Un nombre único e interno que te ayude a identificar este link dentro de tu organización.</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-0 background" style="height: calc(100vh - 225px); overflow-y: auto;">
          <v-row class="fill-height">
            <v-col cols="4" class="fill-height overflow-y-auto">

              <!-- step 1 -->
              <template v-if="step === 1">
                <v-list class="transparent">
                  <v-list-item class="py-2 px-0">
                    <v-list-item-title class="pl-1 body-2 text--secondary font-weight-medium">Página de pago <v-icon color="secondary" size="18">mdi-chevron-right</v-icon> Precio</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">Moneda</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="8" class="pa-0">
                          <v-select v-model="object.currency" background-color="white" dense :items="currencies" item-text="name" item-value="id" height="30" hide-details :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" outlined single-line />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">Tipo de precio</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="8" class="pa-0">
                          <v-select v-model="object.amount_scheme" background-color="white" dense :items="amountSchemes" item-text="name" item-value="id" height="30" hide-details :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" outlined single-line />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <!-- custom amount -->
                  <template v-if="object.amount_scheme === 'custom'">
                    <v-list-item class="px-0 pb-0">
                      <v-list-item-content>
                        <v-list-item-title class="pl-1">
                          Monto sugerido
                          <v-tooltip right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                            </template>
                            <span>A los clientes se les sugerirá este monto, aunque pueden elegir uno diferente.</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-col cols="4" class="pa-0">
                            <v-text-field v-model="$v.object.amount_preset.$model" autocomplete="off" background-color="white" dense :error="$v.object.amount_preset.$error" hide-details maxlength="8" outlined persistent-hint required single-line />
                          </v-col>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-0 pb-0">
                      <v-list-item-content>
                        <v-list-item-title class="pl-1">
                          Límites de monto
                          <v-tooltip right max-width="280px" transition="scale-transition">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" small color="secondary">mdi-information</v-icon>
                            </template>
                            <span>Fija un mínimo, máximo o ambos para limitar el monto que pueden pagar tus clientes.</span>
                          </v-tooltip>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <v-row class="pt-1">
                            <v-col cols="5" class="py-0">
                              <v-list-item-title class="pl-1">Monto mínimo</v-list-item-title>
                              <v-text-field v-model.number="$v.object.amount_min.$model" autocomplete="off" background-color="white" dense :error="$v.object.amount_min.$error" hide-details maxlength="8" outlined persistent-hint required single-line />
                            </v-col>
                            <v-col cols="5" class="py-0">
                              <v-list-item-title class="pl-1">Monto máximo</v-list-item-title>
                              <v-text-field v-model.number="$v.object.amount_max.$model" autocomplete="off" background-color="white" dense :error="$v.object.amount_max.$error" hide-details maxlength="8" outlined persistent-hint required single-line />
                            </v-col>
                          </v-row>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="px-1" v-if="!$v.object.amount_min.max || !$v.object.amount_max.min || !$v.object.amount_preset.min || !$v.object.amount_preset.max">
                      <v-list-item-content>
                        <span v-if="!$v.object.amount_min.max" class="red--text">El monto máximo debe ser menor a {{ object.amount_max | currency(object.currency) }}</span>
                        <span v-if="!$v.object.amount_max.min" class="red--text">El monto máximo debe ser mayor a {{ object.amount_min | currency(object.currency) }}</span>
                        <span v-if="!$v.object.amount_preset.min" class="red--text">El monto sugerido debe ser mayor o igual a {{ object.amount_min | currency(object.currency) }}</span>
                        <span v-if="!$v.object.amount_preset.max" class="red--text">El monto sugerido debe ser menor o igual a {{ object.amount_max | currency(object.currency) }}</span>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <!-- end custom amount -->

                  <!-- fixed amount -->
                  <template v-if="object.amount_scheme === 'fixed'">
                    <v-list-item class="px-0 pb-0">
                      <v-list-item-content>
                        <v-list-item-title class="pl-1">Monto</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-col cols="4" class="pa-0">
                            <v-text-field v-model="$v.object.amount.$model" autocomplete="off" background-color="white" dense :error="$v.object.amount.$error" hide-details maxlength="8" outlined persistent-hint required single-line />
                          </v-col>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <!-- end fixed amount -->

                </v-list>
              </template>
              <!-- end step 1 -->

              <!-- step 2 -->
              <template v-if="step === 2">
                <v-list class="transparent">
                  <v-list-item class="py-2 px-0">
                    <v-list-item-title class="pl-1 body-2 text--secondary font-weight-medium">Página de pago <v-icon color="secondary" size="18">mdi-chevron-right</v-icon> Más opciones</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">Descripción</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-text-field v-model.trim="$v.object.description.$model" background-color="white" dense :error="$v.object.description.$error" hide-details maxlength="128" outlined persistent-hint required single-line />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">Tipo de consumidor</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="8" class="pa-0">
                          <v-select v-model="object.customer_type" background-color="white" dense :items="customerTypes" item-text="name" item-value="id" height="30" hide-details :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" outlined single-line />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">Llamado a la acción</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="4" class="pa-0">
                          <v-select v-model="object.cta" background-color="white" dense :items="ctas" item-text="name" item-value="id" height="30" hide-details :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" outlined single-line />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <!-- end step 2 -->

              <!-- step 3 -->
              <template v-else-if="step === 3">
                <v-list class="transparent">
                  <v-list-item class="py-2 px-0">
                    <v-list-item-title class="pl-1 body-2 text--secondary font-weight-medium">Después del pago</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="px-0">
                    <v-list-item-content>
                      <v-radio-group v-for="d in afterConfirmSchemes" v-model="afterConfirm" class="my-2" hide-details :key="d.id">
                        <v-radio :label="d.name" :value="d.id" />
                      </v-radio-group>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-if="afterConfirm === 'display_message'" class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">Personalizar el mensaje de confirmación</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-text-field v-model.trim="$v.object.end_description.$model" background-color="white" dense :error="$v.object.end_description.$error" hide-details maxlength="128" outlined persistent-hint placeholder="Gracias por tu pago" required single-line />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-else-if="afterConfirm === 'redirect'" class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">URL para la redirección</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-text-field v-model.trim="$v.object.return_url.$model" background-color="white" dense :error="$v.object.return_url.$error" hide-details maxlength="128" outlined persistent-hint placeholder="https://www.example.com" required single-line />
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-list class="mt-6 transparent">
                  <v-list-item class="py-2 px-0">
                    <v-list-item-title class="pl-1 body-2 text--secondary font-weight-medium">Facturación</v-list-item-title>
                  </v-list-item>
                  <v-list-item class="py-2 px-0">
                    <v-list-item-title class="pl-1">Crear una factura posterior al pago</v-list-item-title>
                    <v-list-item-action>
                      <v-switch class="mr-3" v-model="object.create_invoice" />
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item v-if="object.create_invoice" class="px-0 pb-0">
                    <v-list-item-content>
                      <v-list-item-title class="pl-1">Tipo de documento</v-list-item-title>
                      <v-list-item-subtitle>
                        <v-col cols="8" class="pa-0">
                          <v-select v-model="$v.object.document.$model" :error="$v.object.document.$error" :items="documentChoices" item-value="id" item-text="name" label="Selecciona un tipo de factura" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details />
                        </v-col>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </template>
              <!-- end step 3 -->
            </v-col>
            <v-divider vertical />
            <v-col class="px-10 fill-height overflow-y-auto">
              <div style="transform: scale(80%)">
                <link-demo :data="object" :step="step" />
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="py-0 px-4">
          <v-row align="center">
            <v-col cols="4">
              <v-row no-gutters>
                <v-btn v-if="step > 1" @click="step = step - 1" outlined :ripple="false">Atras</v-btn>
                <v-spacer />
                <v-btn v-if="step < 3" @click="step = step + 1" :loading="$store.state.apps.createLoader" color="primary" :ripple="false">Continuar</v-btn>
                <v-btn v-if="step === 3" @click="saveObject" :loading="$store.state.apps.createLoader" color="primary" :ripple="false">
                  <template v-if="isEditing">Guardar cambios</template>
                  <template v-else>Crear enlace</template>
                </v-btn>
              </v-row>
            </v-col>
            <v-divider vertical />
            <!-- <v-col v-if="step === 3">
              <span class="body-2 red--text" v-if="$v.object.available_plans.$invalid || $v.newForm.available_addons.$invalid"><v-icon color="red" left size="20">mdi-alert</v-icon>Corrige los campos marcados con error en la <v-btn class="mt-n1 text-decoration-underline" @click="step=1" text color="red" :ripple="false">sección de Productos</v-btn></span>
              <span class="body-2 red--text" v-else-if="$v.object.available_countries.$invalid || $v.newForm.available_documents.$invalid"><v-icon color="red" left size="20">mdi-alert</v-icon>Corrige los campos marcados con error en la <v-btn class="mt-n1 text-decoration-underline" @click="step=2" text color="red" :ripple="false">sección de Facturación</v-btn></span>
            </v-col> -->
          </v-row>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { numeric, required, requiredIf, maxLength, url } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'

import GenericViewMixin from '@/mixins/GenericViewMixin'
import { invoiceTypeSelectOptions } from '@/collections/documents'

import LinkDemo from '@/components/links/LinkDemo'

export default {
  components: {
    LinkDemo
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    afterConfirm: 'display_message',
    afterConfirmSchemes: [
      { id: 'display_message', name: 'Mostrar un mensaje de confirmación' },
      { id: 'redirect', name: 'Redireccionar a los clientes a mi sitio web' }
    ],
    amountSchemes: [
      { id: 'fixed', name: 'Precio fijo' },
      { id: 'custom', name: 'Los clientes eligen que pagar' }
    ],
    ctas: [
      { id: 'pay', name: 'Pagar' },
      { id: 'donate', name: 'Donar' },
      { id: 'book', name: 'Reservar' }
    ],
    currentCurrency: null,
    customerTypes: [
      { id: 'both', name: 'Empresa o Persona' },
      { id: 'business', name: 'Empresa' },
      { id: 'individual', name: 'Persona' }
    ],
    documentChoices: [],
    isEditing: false,
    object: {
      amount: null,
      amount_min: null,
      amount_max: null,
      amount_preset: null,
      amount_scheme: 'fixed',
      create_invoice: false,
      cta: 'pay',
      currency: null,
      customer_type: 'both',
      description: '',
      document: null,
      end_description: '',
      image: null,
      name: 'Nuevo link de pago',
      return_url: ''
    },
    step: 1
  }),
  computed: mapState({
    instance: state => state.apps.linksDetail
  }),
  created () {
    this.documentChoices = invoiceTypeSelectOptions(
      this.account.country.id,
      this.account.country.name
    )

    // evaluate if editing and retrieve object if so
    // else set default currency based on account base currency
    if (this.$route.params.id) {
      this.isEditing = true

      this.$store.dispatch('apps/RETRIEVE', {
        resource: 'payment_links/links',
        id: this.$route.params.id
      })
      .then(() => {
        // clone object to avoid reactivity
        const clone = cloneDeep(this.instance)

        Object.keys(this.object).forEach(k => {
          this.object[k] = clone[k]
        })
      })
      .then(() => {
        // set after confirm scheme
        if (this.isEditing) {
          if (this.instance.return_url) {
            this.afterConfirm = 'redirect'
          } else if (this.instance.end_description) {
            this.afterConfirm = 'display_message'
          }
        }
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })

      return
    }

    // set default currency based on account base currency
    this.object.currency = this.account.base_currency.id
  },
  methods: {
    saveObject () {
      this.$v.object.$touch()

      if (this.$v.object.$invalid) {
        return false
      }

      const payload = Object.assign({}, this.object)

      // remove end_description if return_url is set
      // priority is to redirect to the URL
      if (this.afterConfirm === 'redirect') {
        payload.end_description = null
      } else if (this.afterConfirm === 'display_message') {
        payload.return_url = null
      }

      if (!payload.create_invoice) {
        payload.document = null
      }

      const action = this.isEditing ? 'UPDATE' : 'CREATE'
      const options = {
        resource: 'payment_links/links',
        payload: payload
      }

      if (this.isEditing) {
        options.id = this.$route.params.id
      }

      this.$store.dispatch(`apps/${action}`, options)
      .then((response) => {
        this.$router.push({
          name: 'LinkRetrieve',
          params: {
            id: response.data.id
          },
          query: {
            ref: 'setup'
          }
        })
        this.$dialog.message.info(`En link de pago se ha ${this.isEditing ? 'actualizado' : 'creado'} exitosamente.`)
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    object: {
      amount: {
        numeric,
        requiredIf: requiredIf(function () {
          return this.object.amount_scheme === 'fixed'
        })
      },
      amount_min: {
        numeric,
        max: function () {
          if (this.object.amount_max && this.object.amount_max <= this.object.amount_min) {
            return false
          }
          return true
        }
      },
      amount_max: {
        numeric,
        min: function () {
          if (this.object.amount_min && this.object.amount_min >= this.object.amount_max) {
            return false
          }
          return true
        }
      },
      amount_preset: {
        numeric,
        min: function () {
          if (this.object.amount_min && this.object.amount_min > this.object.amount_preset) {
            return false
          }
          return true
        },
        max: function () {
          if (this.object.amount_max && this.object.amount_max < this.object.amount_preset) {
            return false
          }
          return true
        }
      },
      currency: {
        required
      },
      description: {
        required,
        maxLength: maxLength(128)
      },
      document: {
        requiredIf: requiredIf(function () {
          return this.object.create_invoice
        })
      },
      end_description: {
        maxLength: maxLength(128)
      },
      name: {
        required,
        maxLength: maxLength(56)
      },
      return_url: {
        url,
        maxLength: maxLength(256)
      }
    }
  }
}
</script>
